import { LegalLayout, LegalSection as S } from "../components/LegalLayout";
import { COMPANY as C } from "../constants/company";

const Mail = () => <a href={`mailto:${C.email}`} className="underline decoration-coral decoration-2 underline-offset-4">{C.email}</a>;

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated={C.updated} testid="privacy-page">
      <S title="Who we are">
        <p>Reuben's Reads is a trading name of {C.name}, a company registered in England and Wales (company number {C.number}).
          Our postal address is {C.address}. We are responsible for the personal information you give us when you buy a book.</p>
        <p>If you have any questions about this policy, email us at <Mail />.</p>
      </S>
      <S title="What we collect">
        <p>When you buy a book we collect your name, email address, delivery address and billing address, plus details of what you ordered.</p>
        <p>Your card details are entered on Stripe's secure checkout page. We never see or store your full card number.</p>
      </S>
      <S title="Why we use it">
        <p>We use your information to take payment, post your book, email you about your order, and keep the records a business must keep by law.
          The legal basis is that we need it to fulfil our contract with you, and to meet our legal obligations.</p>
        <p>We don't send marketing emails, and we never sell your information.</p>
      </S>
      <S title="Who we share it with">
        <p>We only share your information with the services that help us run the shop:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Stripe, which processes payments</li>
          <li>our email provider, which sends order confirmation emails</li>
          <li>the postal service that delivers your book</li>
        </ul>
      </S>
      <S title="How long we keep it">
        <p>We keep order records for up to 6 years, as UK tax rules require, and then delete them.</p>
      </S>
      <S title="Cookies">
        <p>Our website doesn't use tracking or advertising cookies. When you go to checkout, Stripe may set cookies on its own payment page to keep payments secure.</p>
      </S>
      <S title="Your rights">
        <p>You can ask to see, correct or delete the information we hold about you, or object to how we use it. Email <Mail /> and we'll reply within one month.</p>
        <p>If you're unhappy with how we've handled your information, you can complain to the Information Commissioner's Office (ICO) at ico.org.uk.</p>
      </S>
    </LegalLayout>
  );
}
